// @flow
import * as React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { useNoteForm, withNoteForm } from '../../../../../features/note-form';
import { useClient } from '../../../hooks/client-context';
import { keycloak, KeycloakRoles } from '@coverright/shared/keycloak';


const NoteButton = (props: ButtonProps) => {
  const {onClick, ...rest} = props;
  const client = useClient();
  const {open} = useNoteForm()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    open(client.id);
    onClick && onClick(e);
  }

  return (
    <Button size={'small'} {...rest} onClick={handleClick}>Add note</Button>
  );
};

const ManagerNoteButton = (props: ButtonProps) => {
  const isAgentManager = keycloak?.realmAccess?.roles?.includes(KeycloakRoles.ROLE_AGENT_MANAGER);
  const {onClick, ...rest} = props;
  const client = useClient();
  const {open} = useNoteForm()

  if (!isAgentManager) return null;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    open(client.id, undefined, true);
    onClick && onClick(e);
  }

  return (
    <Button size={'small'} {...rest} onClick={handleClick}
            sx={{borderColor: '#FECACA', color: '#DC2626', '&:hover': {borderColor: '#FCA5A5', bgcolor: '#FEF2F2'}, ...props.sx}}
            variant={'outlined'}>
      Add manager note
    </Button>
  );
};

export const AddNoteButton = withNoteForm(NoteButton)
export const AddManagerNoteButton = withNoteForm(ManagerNoteButton)
